import script from "./ContentAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentAdd.vue?vue&type=script&setup=true&lang=js"

import "./ContentAdd.vue?vue&type=style&index=0&id=82c7020a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82c7020a"]])

export default __exports__